import { render, staticRenderFns } from "./loadingindex.vue?vue&type=template&id=7b6f789f&scoped=true&"
import script from "./loadingindex.vue?vue&type=script&lang=js&"
export * from "./loadingindex.vue?vue&type=script&lang=js&"
import style0 from "./loadingindex.vue?vue&type=style&index=0&id=7b6f789f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f789f",
  null
  
)

export default component.exports